import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { LogoStyled } from "./styled";
import { ROUTE_PATH } from "utils/constants/routePath";
import { useNavigate } from "react-router-dom";

const Logo = ({ theme_standard, mb, mbNode, nodeLeft, nodeRight }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const navigate = useNavigate();

  return (
    <LogoStyled mb={mb} mbNode={mbNode}>
      <div className={customClass}>
        <div className="h_logo_figure">
          <img
            className="header_img"
            alt="misumi header"
            src="/assets/images/logos/logo.svg"
            onClick={() => navigate(ROUTE_PATH.HOME)}
          />
        </div>
        {(nodeLeft || nodeRight) && (
          <div className="header_info_block">
            <div className="hib_col">{nodeLeft}</div>
            <div className="hib_col">{nodeRight}</div>
          </div>
        )}
      </div>
    </LogoStyled>
  );
};

Logo.propTypes = {};

export default Logo;
